import Store from 'store/store';

const SITE_CONTROLS = 'site-controls';
const AR_EXPERIENCE = 'AR-experience';

const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	window.firePowsterCustomEvent(action, cat, label);
};

// View
Store.on('TRACK_VIEW', ({ cat, label }) => {
	fire('view', cat, label || '-');
});


Store.on('TRACK_LANDING_GO_TO_HABITAT', (scrollOrMenu) => {
	fire('habitat-access', SITE_CONTROLS, scrollOrMenu);
});

Store.on('TRACK_AUDIO_CLICK', (mute) => {
	fire('audio-click', SITE_CONTROLS, mute);
});

Store.on('TRACK_SHARE_SITE_CLICK', () => {
	fire('share-click', SITE_CONTROLS, '-');
});

Store.on('TRACK_HOME_CLICK', () => {
	fire('home-click', SITE_CONTROLS, '-');
});

Store.on('TRACK_ABOUT_CLICK', () => {
	fire('about-the-ou-click', SITE_CONTROLS, '-');
});

Store.on('TRACK_FAQ_CLICK', () => {
	fire('faq-click', SITE_CONTROLS, '-');
});

Store.on('TRACK_CAMERA_PERMISSIONS', (allowOrDeny) => {
	fire('camera-access', SITE_CONTROLS, allowOrDeny);
});

Store.on('TRACK_FOOTER_LINK_CLICK', (link) => {
	fire('footer-click', SITE_CONTROLS, link);
});

Store.on('TRACK_ORIGAMI_CLICK', (animal) => {
	const label = animal?.toLowerCase() || '-';
	fire('origami-click', 'habitat', label);
	fire('view', 'origami', label);
});

Store.on('TRACK_PLEDGE_SHARE_CLICK', (type) => {
	fire('share-click', 'pledge', type);
});

Store.on('TRACK_LAUNCH_AR', (habitat) => {
	fire('AR-launch-click', AR_EXPERIENCE, habitat);
});

Store.on('TRACK_CLOSE_AR_MINI_HELP', () => {
	fire('ar-tips-close', AR_EXPERIENCE, '-');
});

Store.on('TRACK_AR_HOTSPOT_CLICK', (hotspotName) => {
	fire('hotspot-click', AR_EXPERIENCE, hotspotName);
});

Store.on('TRACK_HABITAT_DWELL', ({ seconds, habitatName }) => {
	let timeBracket;
	if (seconds < 31) {
		timeBracket = '0-30s';
	} else if (seconds < 61) {
		timeBracket = '31-60s';
	} else if (seconds < 91) {
		timeBracket = '61-90s';
	} else {
		timeBracket = '91s+';
	}
	fire(`${habitatName}-habitat-dwell`, AR_EXPERIENCE, timeBracket);
});

Store.on('TRACK_AR_HELP_CLICK', () => {
	fire('info-click', AR_EXPERIENCE, '-');
});

Store.on('TRACK_SPLASH_SOCIAL_CLICK', (platform) => {
	if (platform === 'twitter') {
		platform = 'X';
	}
	fire('social-click', 'desktop-splash-page', platform);
});

Store.on('TRACK_ARRIVE_FROM_QR_CODE', () => {
	fire('arrive-from-splash-qr', 'desktop-splash-page', '-');
});

Store.on('TRACK_ARRIVE_FROM_MARKETING', () => {
	fire('arrive-from-marketing', 'marketing', '-');
});
